import { memo, useCallback, useRef } from 'react';
import Box from '@mui/material/Box';
import { useField } from 'formik';
import { useClickOutside } from 'hooks/useClickOutside';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { AppointmentAttachmentSection } from '../CreateAppointmentForm/Attachments';

interface Props {
    isActive: boolean;
    onDeactivate: () => void;
    onActivate: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const imageNameStyles = {
    maxWidth: 200,
};

export const CommentFormContent = memo(({ isActive, onDeactivate, onActivate }: Props) => {
    const [field, , helpers] = useField<string>('message');

    const ref = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleDeactivate = useCallback(() => {
        inputRef.current?.blur();
        onDeactivate();
    }, [onDeactivate, inputRef]);

    const handleChange = useCallback(
        ({ target }: React.ChangeEvent<HTMLInputElement>) => {
            helpers.setValue(target.value);
        },
        [helpers],
    );

    useClickOutside<HTMLDivElement>(ref, handleDeactivate);

    return (
        <Box display="flex" flexDirection="column" gap={1} ref={ref}>
            <TextField
                inputRef={inputRef}
                name="message"
                value={field.value}
                placeholder="Add a comment..."
                variant="outlined"
                onChange={handleChange}
                multiline={isActive}
                onClick={onActivate}
                minRows={3}
            />
            {isActive && (
                <Box display="flex" justifyContent="space-between" width="100%" gap={1}>
                    <Box flex={1} maxWidth={500}>
                        <AppointmentAttachmentSection />
                    </Box>
                    <Box display="flex" gap={1} height={32}>
                        <Button variant="text" onClick={onDeactivate} size="small">
                            Cancel
                        </Button>
                        <Button size="small" variant="contained" type="submit">
                            Comment
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
});

CommentFormContent.displayName = 'CommentFormContent';
